import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Users } from 'lucide-react';
import { AnchoredDropdownMenu } from './AnchoredDropdownMenu';
import { cn } from '@/lib/utils';
import {
	professionalHeaderActionIconClass,
	professionalHeaderControlHeightClass,
} from './professionalHeaderConstants';

const menuItemClass =
	'flex w-full items-center gap-2.5 whitespace-nowrap px-3 py-3 text-left text-sm font-semibold text-stone-700 transition-colors hover:bg-stone-50 focus:outline-none';

const quickActionTriggerClass = cn(
	'inline-flex shrink-0 items-center justify-center rounded-full border-0 bg-brand-purple py-0 font-bold text-white shadow-sm transition-colors hover:bg-brand-purple/90 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-purple/40',
	professionalHeaderControlHeightClass,
	'w-8 px-0 md:w-9',
);

type ProfessionalHeaderQuickActionsMenuProps = {
	onCreateSession: () => void;
};

const ProfessionalHeaderQuickActionsMenu = ({
	onCreateSession,
}: ProfessionalHeaderQuickActionsMenuProps) => {
	const navigate = useNavigate();
	const [open, setOpen] = useState(false);

	const closeMenu = () => setOpen(false);

	return (
		<div className="min-[700px]:hidden">
			<AnchoredDropdownMenu
				open={open}
				onOpenChange={setOpen}
				menuWidth={176}
				estimatedHeight={96}
				menuClassName="w-44 max-w-[calc(100vw-1rem)] overflow-x-hidden p-0 animate-in fade-in zoom-in-95 duration-100"
				trigger={({
					ref: setAnchorRef,
					isOpen: menuOpen,
					onTriggerClick,
				}) => (
					<button
						ref={setAnchorRef}
						type="button"
						onClick={onTriggerClick}
						className={cn(
							quickActionTriggerClass,
							menuOpen && 'bg-brand-purple/90',
						)}
						aria-label="Ações rápidas"
						aria-expanded={menuOpen}
						aria-haspopup="menu"
					>
						<Plus
							className={cn(
								professionalHeaderActionIconClass,
								'stroke-[3] text-white',
							)}
						/>
					</button>
				)}
			>
				<div className="flex flex-col py-1">
					<button
						type="button"
						onClick={() => {
							closeMenu();
							navigate('/profissional/pacientes');
						}}
						className={menuItemClass}
						role="menuitem"
					>
						<Users
							className="size-[18px] shrink-0 text-stone-500"
							strokeWidth={2}
						/>
						Pacientes
					</button>

					<button
						type="button"
						onClick={() => {
							closeMenu();
							onCreateSession();
						}}
						className={menuItemClass}
						role="menuitem"
					>
						<Plus
							className="size-[18px] shrink-0 text-stone-500"
							strokeWidth={2.5}
						/>
						Nova consulta
					</button>
				</div>
			</AnchoredDropdownMenu>
		</div>
	);
};

export { ProfessionalHeaderQuickActionsMenu };
